import { CheckIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import Button from './Button';
import CopyToClipboard from './CopyToClipboard';

const CodeBlock = ({ copy, children }) => {
  const [copied, setCopied] = useState(false);

  return (
    <div className="rounded text-white dark:text-foreground bg-gray-900 dark:bg-muted text-xs flex flex-col">
      <div className="font-mono text-sm px-4 pt-4 whitespace-pre-line break-all">{children}</div>

      {copy && (
        <div className="ml-auto flex items-center p-2">
          <CopyToClipboard
            text={children}
            onCopy={() => {
              setCopied(true);

              window.setTimeout(() => {
                setCopied(false);
              }, 1000);
            }}
          >
            <Button
              className="bg-transparent text-white border-white dark:border-border hover:bg-white/10 hover:text-white"
              size="small"
            >
              {/* Browser page translation moves bare text nodes into <font> wrappers, so swap
                  whole elements: React then never removes a text node it no longer owns. */}
              {copied ? (
                <div className="flex gap-x-1 items-center">
                  <CheckIcon className="w-4 h-4" /> Copied
                </div>
              ) : (
                <span>Copy</span>
              )}
            </Button>
          </CopyToClipboard>
        </div>
      )}
    </div>
  );
};

export default CodeBlock;
